import React from "react";

export const ReloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 24}
    height={props.height ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
<path d="M20 8C18.4 5.8 16 3 11.8 3C6.8 3 3 7 3 12C3 17 7 21 11.8 21C14.4 21 16.8 19.8 18.4 18M21 3V8C21 8.6 20.6 9 20 9H15" stroke={props.stroke ?? "currentColor"} strokeWidth={props.strokeWidth ?? 2} strokeLinecap="round"/>
  </svg>
);

export default ReloadIcon;



